import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

import Authorized from './components/Authorized'

import './App.css'

@withRouter
class App extends Component {
  
  render () {
    const { location: {pathname} } = this.props
    return (
      <div className="app-content">
        { this.props.children}
        <Authorized pathname = {pathname} /> 
      </div>
    )
  }
}

export default App